/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DocumentoVersioneSintesiDTO { 
    numero?: number;
    titolo_it?: string;
    pubblicato_at?: string;
    corretto_at?: string;
}

